import React from 'react'
import PropTypes from 'prop-types'
import { getFullPath } from 'lib/location'
import { ViewRouterContext } from './ViewRouter'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { ERRORS } from 'lib/errors'

import Route from './Route'
import AuthLogic from './Auth/AuthLogic'
import ErrorComponent from './Errors/ErrorComponent'

const PrivateRoute = ({ render, loginUserSourceLabeling, component: Component, ...rest }) => {
    const location = useLocation()
    const queryParams = queryString.parse(location.search)

    return (
        <ViewRouterContext.Consumer>
            {({ loggedIn }) => (
                <Route
                    {...rest}
                    isPrivateRoute={true}
                    render={(props) => loggedIn === true
                        ? (render ? render(props) : <Component {...props} />)
                        : (
                            queryParams.loginRedirect === '1' ? (
                                <ErrorComponent error={ERRORS.NETWORK_ERROR_401} />
                            ) : (
                                <AuthLogic
                                    onMount={({ login }) => login({
                                        successTarget: getFullPath(props.location),
                                        userSourceLabeling: loginUserSourceLabeling,
                                    })}
                                />
                            )
                        )}
                />
            )}
        </ViewRouterContext.Consumer>
    )
}

PrivateRoute.propTypes = {
    primaryCategory: PropTypes.string.isRequired,
    pageType: PropTypes.string.isRequired,
    routeId: PropTypes.string,
    render: PropTypes.func,
    component: PropTypes.any,
    loginUserSourceLabeling: PropTypes.shape({
        source: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }),
}

export default PrivateRoute
